"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionsGroups = void 0;
var ERequestMethod_1 = require("@r1-frontend/api-domru/core/types/ERequestMethod");
/**
 * Конфигурация запроса получения регионов
 * @param sortBy - сортировка регионов (по любому ключу интерфейса IRegion)
 * @param groupBy - группировать регионы по первой букве
 * https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%93%D0%95%D0%9E/02f89bce1a45c3bdc4b5012c0d245869
 */
exports.getRegionsGroups = function (providerId, queryParams) { return ({
    uri: '/v1/geography/get-regions',
    method: ERequestMethod_1.ERequestMethod.GET,
    headers: { 'ProviderId': "" + providerId },
    queryParams: queryParams,
}); };
